import React from 'react'

// Styles
import style from './FeaturedDownload.module.scss'

const FeaturedDownload = ({ data }) => {
  return (
    <>
      <div className={style.cta}>
        <div dangerouslySetInnerHTML={{ __html: data.cta.content }} />
      </div>
    </>
  )
}

export default FeaturedDownload
